export const px = (value: any): string => (typeof value === 'number' ? `${value}px` : value);
